import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const HEADLINE = `Potholes along the customer journey emerge.`
const DESCRIPTION = `Despite consumers using more channels and devices than ever before, few businesses are prepared to deliver consistent, personalized experiences across channels.`

const PotholesAlongTheCustomerJourney: FC = () => (
  <StyledSectionBase variant="centered">
    <StyledSectionContents>
      <CopyTextBase centered={true}>
        <CopyText.Heading tag="h2" variant="h2">
          {HEADLINE}
        </CopyText.Heading>
        <CopyText.Description tag="p" variant="pLarge">
          {DESCRIPTION}
        </CopyText.Description>
      </CopyTextBase>
    </StyledSectionContents>
  </StyledSectionBase>
)

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`
const StyledSectionContents = styled(Section.Contents)`
  max-width: 684px;
`

export default PotholesAlongTheCustomerJourney
